'use strict';

var classof = require('../internals/classof');

var TO_STRING_TAG = require('../internals/well-known-symbol')('toStringTag');

var test = {};
test[TO_STRING_TAG] = 'z'; // `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring

module.exports = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;